import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/agent/configuration/generateToken/filter'; // Importing Filters component
import Table from 'views/agent/configuration/generateToken/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the generateTokenAgentListView.
 * @extends JetView
 */
export default class generateTokenAgentListView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size from configuration
                },
            ],
        };

        // Left panel configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Apply the current theme
                    elements: [
                        {
                            view: 'label', // Label for the toolbar
                            label: _('Generar Token'), // Translated label text
                            width: 150,
                        },
                    ],
                },
                Filters, // Including Filters component
                Table, // Including Table component
                toolbar, // Including the toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Return the main layout configuration
        return {
            type: 'wide', // Layout type
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
